import { render, staticRenderFns } from "./SupplierHome.vue?vue&type=template&id=88a72a3c&scoped=true&"
import script from "./SupplierHome.vue?vue&type=script&lang=js&"
export * from "./SupplierHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a72a3c",
  null
  
)

export default component.exports